import imgIssues from "../../assets/ac72415613ebf773d431884afee86bbfe92d8190.png";

export default function IssuesSection() {
  return (
    <section id="issues" className="relative w-full bg-[#00499d] py-12 md:py-20 lg:py-[140px]">
      {/* Bottom-half image; top-half remains solid blue */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-1/2 z-0">
        {/* Image at 50% opacity */}
        <img
          src={imgIssues}
          alt="Issues background"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
        {/* Blue overlay to fully tint image area, like previous */}
        <div className="absolute inset-0 bg-[#00499d] mix-blend-multiply" />
        {/* subtle fade at top of image area to blend into solid top-half */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#00499d] via-[#00499d]/60 to-transparent" />
      </div>
      {/* Full-section gradient: lighter at top, darker at bottom */}
      <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-b from-transparent via-[#00499d]/40 to-[#003169]" />

      <div className="relative z-20 max-w-[1200px] mx-auto px-4 md:px-16 lg:px-[100px] text-white">
        <div className="bg-[#003776] border border-[#003169] rounded px-6 py-8 md:px-12 md:py-12 lg:px-[104px] lg:py-[85px] space-y-6 md:space-y-8 lg:space-y-[50px]">
          <h2 className="text-xl md:text-3xl lg:text-4xl font-bold">Ontario at a Crossroads</h2>
          <div className="text-sm md:text-base lg:text-lg space-y-3 md:space-y-4 leading-relaxed">
            <p>
              If Ontario were an American state, it would be the third poorest. Our GDP per capita now trails every G7
              country except Italy, and a decade of flat productivity growth ranks us last among Canada's provinces.
            </p>
            <p>
              We've got many big problems we need to address, from unaffordable housing and heavy traffic congestion to
              poor quality healthcare and limited choice in childcare and education. Despite being heavily taxed, we've
              also got the largest subnational debt in the world.
            </p>
            <p>
              For the first time in recent memory, most Ontarians believe their children will have fewer opportunities
              than they did. Increasing numbers of young people are moving to other provinces or south to the United
              States for a better life.
            </p>
            <p>
              And yet our fundamentals remain strong. We have a deep talent pool, world-class institutions, abundant
              clean electricity, and unmatched access to the North American market.
            </p>
            <p>
              With a clear vision, bold policy, and concerted effort from government, business, and civil society, we can
              restore prosperity, affordability, and opportunity across the province.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
